import React, { useState, useLayoutEffect } from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import Button from './Button';
import AppLink from './renderers/Link';
import LogoSVG from '../svg/logo.svg';
import MenuToggle from './MenuToggle';
import MainNav from './MainNav';
import {
  useNavigationState,
  useNavigationDispatch,
} from '../contexts/navigation';
import useWindowYOffset from '../hooks/useWindowYOffset';

const Header = () => {
  const { isFirstRender, isYScrolled } = useWindowYOffset();
  const [windowWidth, setWindowWidth] = useState(0);

  const { isOpen } = useNavigationState();
  const { closeNav, toggleNav } = useNavigationDispatch();

  useLayoutEffect(() => {
    const handleWindowWidthChange = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowWidthChange);
    if (windowWidth >= 1024 && isOpen) {
      closeNav();
    }
    return () => window.removeEventListener('resize', handleWindowWidthChange);
  }, [windowWidth, isOpen, closeNav]);
  
  const wrapperClass = classnames("fixed top-0 z-50 bg-white bg-opacity-0 w-full py-6 lg:py-4",
  {
    "shadow-2xl bg-opacity-100": isYScrolled,
    "transition duration-300": !isFirstRender,
    "bg-opacity-100": isOpen,
  });

  return (
    <div className={wrapperClass}>
      <div
        className="site-nav leading-relaxed flex flex-col max-w-6xl lg:flex-row lg:justify-between lg:mx-auto lg:h-14 xl:px-0"
      >
        <div className="px-6 flex flex-row items-center justify-between w-full lg:w-auto">
          <Link to="/" onClick={closeNav}>
            <span className="sr-only">GraphCMS</span>
            <LogoSVG className="h-8 fill-current lg:h-11" />
          </Link>

          <div className="appearance-none flex flex-row justify-between items-center lg:hidden text-haiti">
            <Button
              colour="pink"
              size="small"
              href="/contact"
              onClick={closeNav}
            >
              Contact Sales
            </Button>

            <MenuToggle
              className="ml-6 text-haiti"
              onClick={toggleNav}
              open={isOpen}
            />
          </div>
        </div>

        <MainNav />

        <ul className="auth-nav hidden lg:flex lg:flex-row lg:w-auto lg:justify-evenly lg:items-center lg:whitespace-no-wrap">
          <li className="lg:mr-4 xl:mr-5">
            <AppLink
              href="https://app.graphcms.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-haiti font-bold lg:text-sm"
            >
              Login
            </AppLink>
          </li>

          <li className="lg:mx-4 xl:mx-5">
            <AppLink
              href="https://app.graphcms.com/signup"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-haiti font-bold lg:text-sm"
            >
              Sign Up
            </AppLink>
          </li>

          <li className="ignore-opacity lg:ml-4 xl:ml-5 lg:mr-6">
            <Button
              colour="pink"
              href="/contact"
              size="small"
              onClick={closeNav}
            >
              Contact Sales
            </Button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
